import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { CardActions, Chip, Typography } from '@material-ui/core'

import { Button } from 'components/inputs/Button/Button'
import { DeleteButton } from 'components/inputs/DeleteButton/DeleteButton'

const ConfiguredChip = styled(Chip)`
  ${({ theme }) => css`
    color: ${theme.palette.success.dark};
    border-color: ${theme.palette.success.main};

    & .MuiChip-icon {
      color: ${theme.palette.success.main};
    }
  `}
`

const NotConfiguredChip = styled(Chip)`
  ${({ theme }) => css`
    color: ${theme.palette.warning.dark};
    border-color: ${theme.palette.warning.main};

    & .MuiChip-icon {
      color: ${theme.palette.warning.main};
    }
  `}
`

const FieldHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing(1.5)}px;
`

const KeyStoredStatus = styled(Typography)`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(0.5)}px;
    color: ${theme.palette.success.dark};
  `}
`

const Actions = styled(CardActions)`
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(2)}px;
`

const RemoveKeyButton = styled(DeleteButton)`
  width: auto;
`

const SaveButton = styled(Button)`
  width: auto;
  margin-left: auto;
`

export {
  ConfiguredChip,
  NotConfiguredChip,
  FieldHeader,
  KeyStoredStatus,
  Actions,
  RemoveKeyButton,
  SaveButton,
}
